import { render, staticRenderFns } from "./color_editor.vue?vue&type=template&id=94028992&scoped=true&lang=pug&"
import script from "./color_editor.vue?vue&type=script&lang=js&"
export * from "./color_editor.vue?vue&type=script&lang=js&"
import style0 from "./color_editor.vue?vue&type=style&index=0&id=94028992&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94028992",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('94028992', component.options)
    } else {
      api.reload('94028992', component.options)
    }
    module.hot.accept("./color_editor.vue?vue&type=template&id=94028992&scoped=true&lang=pug&", function () {
      api.rerender('94028992', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form_element/color_editor.vue"
export default component.exports